import type { ProjectKind } from '../api/types';

// Vertriebsart eines Projekts (unveränderlich nach der Anlage).
export const projectKindLabels: Record<ProjectKind, string> = {
  STANDARD: 'Normal',
  ONLINE_REMOTE: 'Online-Remote',
};

export const projectKindDescriptions: Record<ProjectKind, string> = {
  STANDARD: 'Projekt eines Maklers oder einer Vertriebsorganisation.',
  ONLINE_REMOTE:
    'Der Support übernimmt die Maklerstrecke telefonisch und digital. Es nimmt nur Datensätze auf, die nie einem normalen Projekt zugeordnet waren, im freigegebenen Gebiet liegen und nicht im Gebiet eines aktiven normalen Projekts.',
};

export const isRemote = (p: { kind: ProjectKind }) => p.kind === 'ONLINE_REMOTE';
